// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unconverted-instruments-widget{text-align:center}`, "",{"version":3,"sources":["webpack://./src/elements/report-widgets/unconverted-instruments-widget/unconverted-instruments-widget.scss"],"names":[],"mappings":"AAAA,gCAAgC,iBAAiB","sourcesContent":[".unconverted-instruments-widget{text-align:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
